// extracted by mini-css-extract-plugin
module.exports = {"like":"dVk9L","not-clickable":"_3d-Ah","notClickable":"_3d-Ah","likebutton":"_14nQ7","likes":"_21nYu"};